import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouterProvider } from 'react-router';
import router from './router';
import Loader from "./components/Loader";
import openApi from "./api/open/index";
import { ToastContainer } from "react-toastify";
import pack from "../package.json";
import { applyLayoutStylse } from "./helpers/DomHelper";
import LayoutStyles from "./@types/api/styles";
import AlertDialog from "./components/AlertDialog";
import ActionDialog from "./components/ActionDialog";
import moment from "moment";
import config from "./config/default.json";
import orderStore from "./stores/order";
import { hideLoader, showLoader } from "./helpers/ComponentHelper";
import menuStore from "./stores/menu";

const App = () => {
    const [, i18n] = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false);
    const [alertTitle, setAlertTitle] = useState<string>("");
    const [alertText, setAlertText] = useState<string>("");

    const [isOpenActionDialog, setIsOpenActionDialog] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>("");
    const [dialogText, setDialogText] = useState<string>("");
    const [onDialogYes, setOnDialogYes] = useState<() => void>(() => () => { });
    const [onDialogNo, setOnDialogNo] = useState<() => void>(() => () => { });


    useEffect(() => {
        getSettings();
        applyStyles();
        reloadOrder();
    }, []);

    window._changeLang = (lang: string) => {
        i18n.changeLanguage(lang);
    }

    window._setIsLoading = (isLoading: boolean = false) => {
        setIsLoading(isLoading);
    }

    window._isLoading = (): boolean => {
        return isLoading;
    }

    window._showAlert = (title: string, text: string) => {
        setAlertTitle(title);
        setAlertText(text);
        setIsOpenAlert(true);
    }

    window._hideAlert = () => {
        closeAlert();
    }

    window._showDialog = (title: string, text: string, onYes: () => void, onNo: () => void) => {
        setDialogTitle(title);
        setDialogText(text);
        setIsOpenActionDialog(true);
        setOnDialogYes(() => onYes);
        setOnDialogNo(() => onNo);
    }

    window._hideDialog = () => {
        closeDialog();
    }

    const getSettings = async () => {
        const r = await openApi.getGlobalSettings();
        if (r) {
            localStorage.setItem("settings", JSON.stringify(r));
        }
    }

    const applyStyles = () => {
        try {
            const styles = JSON.parse(localStorage.getItem("styles") || "null") as unknown as LayoutStyles;
            if (styles)
                applyLayoutStylse(styles);
        }
        catch {
            // ignore
        }
    }

    const closeAlert = () => {
        setIsOpenAlert(false);
        setAlertTitle("");
        setAlertText("");
    }

    const closeDialog = () => {
        setIsOpenActionDialog(false);
        setDialogTitle("");
        setDialogText("");
    }

    const reloadOrder = async () => {
        const noReloadUrl = ["", "/", "/settings"];
        if (noReloadUrl.indexOf(window.location.pathname.toLocaleLowerCase().trim()) === -1) {
            const orderCreatedAtString = localStorage.getItem("orderId_createdAt");
            if (orderCreatedAtString) {
                const orderCreatedAt = parseInt(orderCreatedAtString, 10);
                if (moment().valueOf() - orderCreatedAt <= config.order.restoreTimeout) {
                    const orderId = localStorage.getItem("orderId");
                    if (orderId) {
                        showLoader();
                        await menuStore.getMenu();
                        await orderStore.reloadOrder(orderId);
                        hideLoader();
                        return;
                    }
                }
            }

            window.location.href = "/";
        }
    }

    return <>
        <div className="appVersion">{pack.version}</div>
        <Loader isLoading={isLoading} />
        <AlertDialog open={isOpenAlert} title={alertTitle} text={alertText} onClose={closeAlert} />
        <ActionDialog open={isOpenActionDialog} title={dialogTitle} text={dialogText} onNo={onDialogNo} onYes={onDialogYes} />
        <RouterProvider router={router} />
        <ToastContainer />
    </>
}

export default App;
